import { useState } from 'react';
import { useIsAdmin } from './use-is-admin';

const STORAGE_KEY = 'naia.admin.showTestData';

function readStored(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function useShowTestData() {
  const isAdmin = useIsAdmin();
  const [enabled, setEnabled] = useState(readStored);

  const set = (value: boolean) => {
    setEnabled(value);
    try {
      localStorage.setItem(STORAGE_KEY, value ? '1' : '0');
    } catch {
      return;
    }
  };

  return { isAdmin, includeTestData: isAdmin && enabled, setIncludeTestData: set };
}

export function ShowTestDataToggle({
  checked,
  onChange,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
}) {
  return (
    <label className="inline-flex items-center gap-2 min-h-[44px] text-[13px] text-[var(--naia-text-secondary)] cursor-pointer">
      <input type="checkbox" checked={checked} onChange={(e) => onChange(e.target.checked)} />
      Afficher les données de test
    </label>
  );
}
